import React, { useEffect, useState } from 'react'
import { Dimensions, FlatList, Text, TouchableOpacity, View, Image, RefreshControl } from 'react-native'
import { getConection } from '../appBar/context/HeaderContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_get_periods_status } from '../../services/schedule.services'
import { Loader } from '../customUtils/Components/Loader'
import { STATUS_PERIOD } from './constants/constants.stores'
import * as Progress from 'react-native-progress'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import styles from './CreateScheduleModeratorStyles'
import theme from '../../../theme'
import { AntDesign, Feather, Ionicons } from '@expo/vector-icons'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { avatarPlaceholder } from '../customUtils/Constants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { set } from 'date-fns'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import type { Period } from './models/CreateScheduleModel'

const { width } = Dimensions.get('window')

export const CreateScheduleModerator = () => {
    const { isConnected } = getConection()
    const [loading, setLoading] = useState(true)
    const [periods, setPeriods] = useState<Period[]>([])
    const [filteredPeriods, setFilteredPeriods] = useState<Period[]>([])
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [refreshing, setRefreshing] = useState(false)

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            setLoading(true)
            {
                fetchData()
            }
        })
        return unsubscribe
    }, [navigation])

    const fetchData = async () => {
        try {
            setRefreshing(true)
            if (isConnected) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data = await request_get_periods_status({ authToken })

                if (!data) {
                    setLoading(false)
                    return
                }
                if (data.periods) {
                    let periods = data.periods ?? []
                    setFilteredPeriods(periods)
                    setPeriods(periods)
                }

                setLoading(false)
            }
        } catch (error) {
            console.log('error', error)
            setLoading(false)
        } finally {
            setRefreshing(false)
        }
    }
    if (loading) {
        return <Loader />
    }
    if (!loading && periods.length === 0) {
        return (
            <View style={styles.containerNoPeriod}>
                <Image style={styles.imageNoPeriod} source={require('../../../assets/noPeriodWeek.png')} />
                <Text style={styles.titleNoPeriod}>Ha ocurrido un error al cargar los periodos de los ejecutivos</Text>
                <Text style={styles.descriptionNoPeriod}>Vuelve a intentarlo más tarde</Text>
                <View style={styles.buttonContainer}>
                    <TouchableOpacity style={styles.mainButton} onPress={() => fetchData()}>
                        <Text style={styles.mainButtonText}>Reintentar</Text>
                    </TouchableOpacity>
                </View>
            </View>
        )
    }
    let validatedUsers = periods.filter((period) => period.status === 1).length ?? 0
    let usersToValidate = periods.filter((period) => period.status != 1).length ?? 0
    let totalUsers = periods.length ?? 0
    let moderatorProgress = (validatedUsers * 100) / totalUsers

    const statusOrder = [9, 8, 7, 0, 3, 5, 1] // Define el orden específico para `status`

    periods.sort((a, b) => {
        // Primero ordenamos por `week`, para que `false` aparezca antes que `true`
        if (a.week === b.week) {
            // Si ambos tienen el mismo valor en `week`, ordenamos por el índice de `status` en `statusOrder`
            const aStatusIndex = statusOrder.indexOf(a.status)
            const bStatusIndex = statusOrder.indexOf(b.status)

            if (aStatusIndex < bStatusIndex) {
                return -1
            }
            if (aStatusIndex > bStatusIndex) {
                return 1
            }
            return 0
        } else {
            // Si `week` es diferente, ordenamos para que `false` venga primero
            return a.week === false ? -1 : 1
        }
    })

    const handlePeriodClick = (period: Period) => {
        if (period.status === STATUS_PERIOD.PENDING_SET_DISTRIBUTORS || period.status === STATUS_PERIOD.PERIOD_APROBB) {
        }
        if (period.status === STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS) {
            navigation.navigate('ModeratorRelevateDistributors', { id_period: period.id_period })
        }
        if (period.week) {
            let params = { id_period: period.id_period, id_week: period.id_week }
            navigation.navigate('ModeratorRelevateWeeks', params)
        }
    }

    return (
        <View style={styles.container}>
            <Text style={styles.title}>Validación de agendas</Text>

            <View style={styles.spacer1}></View>
            <View style={styles.spacer1}></View>

            <Progress.Bar
                progress={moderatorProgress / 100}
                height={8}
                width={width - 24}
                style={styles.progressBar}
                color={colorFilled}
                unfilledColor={colorUnfilled}
            />
            <View style={styles.spacer1}></View>

            <View style={styles.containerRow}>
                <Text style={styles.subtitle}>{'Semanas a validar: '}</Text>
                <Text style={styles.number}>{usersToValidate + ' de ' + totalUsers}</Text>
            </View>

            <View style={styles.spacer1}></View>
            {/*<TouchableOpacity style={[styles.containerRow, styles.margin]}>
                <Text style={styles.textFilter}>Filtros</Text>
                <Ionicons name={'filter-outline'} size={24} color={theme.colors.colorPrimary} />
            </TouchableOpacity>*/}

            <FlatList
                refreshControl={<RefreshControl refreshing={refreshing} onRefresh={fetchData} progressViewOffset={10} />}
                data={filteredPeriods}
                horizontal={false}
                keyExtractor={(item, index) => index.toString()}
                showsVerticalScrollIndicator={false}
                renderItem={({ item: executive }) => {
                    return <ExecutivesScheduleItem data={executive} onClickItem={() => handlePeriodClick(executive)} />
                }}
            />
        </View>
    )
}

export const ExecutivesScheduleItem = ({ data, onClickItem }: any) => {
    const { languageFile } = getLanguage()
    const [avatarUrl, setAvatarUrl] = useState(null)

    getImageStogeUrl(data.user_avatar).then((url) => {
        // console.log(url)
        setAvatarUrl(url)
    })
    return (
        <TouchableOpacity style={styles.cardContainer} onPress={() => onClickItem()}>
            <View>
                <View style={styles.header}>
                    <Image style={styles.image} source={{ uri: avatarUrl ? avatarUrl : avatarPlaceholder }} resizeMode='contain' />
                    {data.user_name && <Text style={styles.headerText}>{data.user_name + (data.user_last_name ?? '')}</Text>}
                    <Text style={styles.separator}>
                        {` | ${data.week ? `${data.schedule_period_name} - ${data.name_week}` : data.schedule_period_name}`}
                    </Text>
                </View>

                <View style={styles.infoContainer}>
                    <Text style={styles.storecode}>EJECUTIVO</Text>

                    <View style={styles.containerData}>
                        <Text style={styles.separator}> | </Text>
                        {/* <Feather name='map-pin' size={14} color={theme.colors.textSecondary} /> */}
                        <Text style={styles.infoText}>{data.user_email}</Text>
                    </View>
                </View>

                <ModeratorScheduleStatusTag status={data.status} />
            </View>
            <Feather name='chevron-right' size={20} color={theme.colors.colorPrimary} style={styles.icon} />
        </TouchableOpacity>
    )
}

export const ModeratorScheduleStatusTag = ({ status }: { status: number }) => {
    switch (status) {
        case STATUS_PERIOD.PENDING_SET_DISTRIBUTORS:
            return (
                <View style={[styles.statusModuleList, { borderColor: theme.colors.error, borderWidth: 1.0, backgroundColor: 'white' }]}>
                    <Text style={[styles.statusModuleText, { color: theme.colors.error }]}>SIN PLANIFICACIÓN</Text>
                </View>
            )
        case STATUS_PERIOD.PERIOD_APROBB:
            return (
                <View style={[styles.statusModuleList, { backgroundColor: theme.colors.colorApproved }]}>
                    <Text style={[styles.statusModuleText, { color: 'white' }]}>APROBADO</Text>
                </View>
            )
        case STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS:
        case STATUS_PERIOD.PENDING_SET_WEEKS:
            return (
                <View style={[styles.statusModuleList, { borderColor: theme.colors.darkGray, borderWidth: 1.0, backgroundColor: 'white' }]}>
                    <Text style={[styles.statusModuleText, { color: theme.colors.darkGray }]}>PENDIENTE POR EL EJECUTIVO</Text>
                </View>
            )
        case STATUS_PERIOD.PENDING_APPROBB_WEEKS:
            return (
                <View style={[styles.statusModuleList, { backgroundColor: theme.colors.colorPending }]}>
                    <Text style={[styles.statusModuleText, { color: 'white' }]}>PENDIENTE DE APROBACIÓN</Text>
                </View>
            )
        case STATUS_PERIOD.PENDING_SET_ACTIVITIES:
        case STATUS_PERIOD.PENDING_APPROBB_ACTIVITIES:
            return (
                <View style={[styles.statusModuleList, { backgroundColor: theme.colors.colorPending }]}>
                    <Text style={[styles.statusModuleText, { color: 'white' }]}>PENDIENTE</Text>
                </View>
            )
        case STATUS_PERIOD.PENDING_SET_MONTHS:
            return (
                <View style={[styles.statusModuleList, { borderColor: theme.colors.error, borderWidth: 1.0, backgroundColor: 'white' }]}>
                    <Text style={[styles.statusModuleText, { color: theme.colors.error }]}>SIN PLANIFICACIÓN</Text>
                </View>
            )
        case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_ACTIVITIES:
        case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_WEEKS:
        case STATUS_PERIOD.PENDING_CHANGE_REQUIRED_DISTRIBUTORS:
            return (
                <View style={[styles.statusModuleList, { backgroundColor: theme.colors.colorDisapproved }]}>
                    <Text style={[styles.statusModuleText, { color: 'white' }]}>MODIFICADO</Text>
                </View>
            )
        default:
            return null
    }
}
